// extracted by mini-css-extract-plugin
export default {"app":"app_app__pSdWx","game__container":"app_game__container__b-Ylg"};